import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaAmortizacaoRepasseComponent } from "./aba-amortizacao-repasse.component";




@NgModule({
    declarations:[
        AbaAmortizacaoRepasseComponent
    ],
    imports:[
        SharedModule
    ],
    exports:[
        AbaAmortizacaoRepasseComponent
    ]
})
export class AbaAmortizacaoRepasseModule {}